import styles from "./Loader.module.scss";
import React from "react";
import PropTypes from "prop-types";
import { Logo } from "../../components";
import lightModeLogo from "../../assets/logos/lightModeLogo.png";
import darkModeLogo from '../../assets/logos/darkModeLogo.png';
import {THEME} from "../../constants";

const Loader = ({theme}) => {
    return (
        <div className={styles.loader}>
            <Logo image={theme === THEME.LIGHT ? lightModeLogo : darkModeLogo}/>
        </div>
    )
}

export default Loader;

Loader.propTypes = {
    theme : PropTypes.string.isRequired
}